// This is a refactored version of the Time.js screen using custom styled button tabs
// with a visual style inspired by the NotificationBell component tabs

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import RestaurantCalendarOpenClosedDays from "../components/restaurant_schedule/RestaurantCalendarOpenClosedDays";
import EstimatedTimePage from "../components/EstimatedTimeCustomersSpend";
import DropDownButton from "../components/DropDownButton";
import {
  fetchRestaurantDetails,
  fetchRestaurantOpenDays,
  updateRestaurant,
  fetchHoursEach,
  fetchPlaceOfTable,
} from "../actions/restaurantActions";
import {
  Container,
  CardHeader,
  CardHeaderTitle,
  FormGroup,
  InsideFormGroup,
  Input,
  InlineText,
  ModernButton,
} from "../components/DefaultImports";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faCalendar,
  faStopwatch,
  faGear,
} from "@fortawesome/free-solid-svg-icons";

function Time() {
  const dispatch = useDispatch();
  const params = useParams();
  const [restaurant_id, setRestaurant_id] = useState(false);

  const [eachTime, setEachTime] = useState("00:15");
  const [acceptPeoplePerEachTime, setAcceptPeoplePerEachTime] = useState("");
  const [limitPeopleReservation, setLimitPeopleReservation] = useState("");
  const [errorMessage, setErrorMessage] = useState("ok_status");
  const [showError, setShowError] = useState(false);
  const [activeTab, setActiveTab] = useState("calendar");

  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurantDetails;

  useEffect(() => {
    if (restaurants) {
      setRestaurant_id(restaurants.id);
      dispatch(fetchPlaceOfTable(restaurants.id));
    }
  }, [restaurants]);

  useEffect(() => {
    dispatch(fetchRestaurantOpenDays(restaurant_id));
    dispatch(fetchHoursEach(restaurant_id));
  }, [dispatch, restaurant_id]);

  useEffect(() => {
    if (restaurants) {
      if (restaurants.each_time) setEachTime(restaurants.each_time);
      if (restaurants.accept_people_per_each_time !== undefined)
        setAcceptPeoplePerEachTime(restaurants.accept_people_per_each_time);
      if (restaurants.limit_people_reservation !== undefined)
        setLimitPeopleReservation(restaurants.limit_people_reservation);
    }
  }, [restaurants]);

  const handleIntervalTimeChange = (option) => setEachTime(option);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "accept_people_per_each_time") {
      setAcceptPeoplePerEachTime(value);
    } else if (name === "limit_people_reservation") {
      setLimitPeopleReservation(value);
    }
  };

  function checkEmptyStates() {
    let emptyStates = [];
    if (!eachTime) emptyStates.push("Cada tempo");
    if (!acceptPeoplePerEachTime || acceptPeoplePerEachTime <= 0)
      emptyStates.push("Capacidade por horário");
    if (!limitPeopleReservation || limitPeopleReservation <= 0)
      emptyStates.push("Limite por grupo");
    return emptyStates.length > 0
      ? `Preencher: ${emptyStates.join(", ")}`
      : "ok_status";
  }

  function checkForErrorsAndUpdateRestaurant() {
    const status_error = checkEmptyStates();
    setErrorMessage(status_error);
    if (status_error === "ok_status") {
      setShowError(false);
      dispatch(
        updateRestaurant(restaurant_id, {
          each_time: eachTime,
          accept_people_per_each_time: acceptPeoplePerEachTime,
          limit_people_reservation: limitPeopleReservation,
        }),
      );
      toast.success("Guardado com sucesso", {
        style: { color: "#EE754C" },
        icon: (
          <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#EE754C" }} />
        ),
        progressStyle: { backgroundColor: "#EE754C" },
        autoClose: 1000,
      });
    } else {
      setShowError(true);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    checkForErrorsAndUpdateRestaurant();
  };

  return (
    <Container>
      <ToastContainer />
      <CardHeader>
        <CardHeaderTitle>Horários</CardHeaderTitle>
      </CardHeader>
      <TabsContainer>
        <StyledTabButton
          active={activeTab === "calendar"}
          onClick={() => setActiveTab("calendar")}
        >
          <FontAwesomeIcon icon={faCalendar} /> Horário
        </StyledTabButton>
        <StyledTabButton
          active={activeTab === "estimated"}
          onClick={() => setActiveTab("estimated")}
        >
          <FontAwesomeIcon icon={faStopwatch} />
          Durações médias
        </StyledTabButton>
        {/*         <StyledTabButton
          active={activeTab === "settings"}
          onClick={() => setActiveTab("settings")}
        >
          <FontAwesomeIcon icon={faGear} /> Definições
        </StyledTabButton> */}
      </TabsContainer>

      {activeTab === "calendar" && (
        <RestaurantCalendarOpenClosedDays restaurant_id={restaurant_id} />
      )}
      {activeTab === "estimated" && (
        <EstimatedTimePage restaurant_ids={restaurant_id} />
      )}

      {activeTab === "settings" && (
        <div
          style={{
            width: "100%",
            display: "flex",
            textAlign: "start",
            justifyContent: "start",
          }}
        >
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <InsideFormGroup>
                <InlineText>Permitir no total</InlineText>
                <Input
                  type="number"
                  id="accept_people_per_each_time"
                  name="accept_people_per_each_time"
                  value={acceptPeoplePerEachTime}
                  onChange={handleChange}
                />
                <InlineText>pessoas a cada</InlineText>
                <DropDownButton
                  options={["00:15", "00:30", "00:45"]}
                  handleOptionChange={handleIntervalTimeChange}
                  initialOption={eachTime}
                />
                <InlineText>minutos</InlineText>
              </InsideFormGroup>
            </FormGroup>

            <FormGroup>
              <InlineText>Número máximo de pessoas por grupo:</InlineText>
              <Input
                type="number"
                id="limit_people_reservation"
                name="limit_people_reservation"
                value={limitPeopleReservation}
                onChange={handleChange}
              />
            </FormGroup>

            {errorMessage !== "ok_status" && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {errorMessage}
              </div>
            )}

            <ModernButton type="submit" color="#ff704d">
              gravar
            </ModernButton>
          </Form>
        </div>
      )}
    </Container>
  );
}

export default Time;

const Form = styled.form`
  max-width: 600px;
  width: 100%;
`;

const TabsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0px 5px;
  height: auto;

  @media (max-width: 768px) {
    padding-top: 0px;
    margin-top: 0px;
    justify-content: center;
  }
`;

const StyledTabButton = styled.button`
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 7px;
  background-color: ${(props) => (props.active ? "#99b0ad" : "#e5eaea")};
  color: ${(props) => (props.active ? "white" : "#4d5e5b")};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) => (props.active ? "#819a97" : "#dce4e4")};
  }

  @media (max-width: 768px) {
    font-size: 14px;
    flex: 1 1 auto;
    justify-content: center;
  }
`;
